<template>
  <div>
    <v-row class="p0-16" no-gutters>
      <v-col cols="12">
        <v-row no-gutters class="justify-space-between flex-nowrap">
          <v-switch
            v-model="sessionReplica.isReplica"
            hide-details
            color="third"
            label="Répliquer les créneaux jusqu’au*"
            class="d-flex align-center mt-0 pt-0"
            :disabled="isReplicaSwitchDisable"
            @change="changeIsReplicaSelection"
          />
          <v-dialog
            v-if="sessionReplica.isReplica"
            ref="dialog"
            v-model="dateModal"
            :return-value.sync="sessionReplica.replica_end_date"
            width="290px"
          >
            <template #activator="{ on, attrs }">
              <v-col cols="2" class="mx-4">
                <v-text-field
                  v-model="sessionReplica.replica_end_date"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  color="third"
                  v-on="on"
                />
              </v-col>
            </template>
            <v-date-picker
              v-model="sessionReplica.replica_end_date"
              :first-day-of-week="1"
              scrollable
              color="third"
              :min="minDate"
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="dateModal = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="saveDate(sessionReplica.replica_end_date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
          <v-checkbox
            v-if="sessionReplica.isReplica"
            v-model="sessionReplica.excludeHolidays"
            :disabled="isReplicaSwitchDisable"
            class="mx-2 my-0 align-center "
            label="exclure les jours fériés"
            color="third"
            hide-details
          />
          <v-checkbox
            v-if="sessionReplica.isReplica"
            v-model="sessionReplica.excludeVacations"
            :disabled="isReplicaSwitchDisable"
            class="mx-2 my-0 align-center "
            label="exclure les vacances scolaires"
            color="third"
            hide-details
          />
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="sessionReplica.isReplica" class="p0-16" no-gutters>
      <v-tabs v-model="sessionReplica.replica_type">
        <v-tab v-for="tabItem in tabs" :key="`tab_switcher_replication_${tabItem.tabKey}`" :disabled="isTabDisable" :href="`#${tabItem.tabKey}`" :class="`${sessionReplica.replica_type === tabItem.tabKey ? 'red--text full-height' : 'grey--text full-height'}`" style="justify-content: start;">
          <span class="ml-2 break-word white-space text-start text-align-last-center">
            {{ tabItem.label }}
          </span>
        </v-tab>

        <v-tabs-slider color="red" />

        <v-tabs-items v-model="sessionReplica.replica_type" class="no-scroll">
          <v-tab-item
            v-for="tabItem in tabs"
            :key="`tab_content_${tabItem.tabKey}`"
            :value="`${tabItem.tabKey}`"
          >
            <component :is="tabItem.component" class="ml-2 mt-5" :date="sessionReplica.replica_end_date" />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-row>
  </div>
</template>

<script>
import { ref, inject, computed } from '@vue/composition-api';
import { add, endOfDay, format, getUnixTime } from 'date-fns';
import { isObjectEmpty } from '@/helpers/utils';
import ReplicationSimple from './ReplicationSimple.vue';
import ReplicationAdvance from './ReplicationAdvance.vue';
import store from '../../../../store';

export default {
  components: {
    ReplicationSimple,
    ReplicationAdvance
  },
  setup () {
    const sessionReplica = inject('sessionReplica');
    const newSession = inject('newSession');
    const resetReplica = inject('resetReplica');
    const editable = inject('editable');
    const oldSessionDetail = inject('oldSessionDetail');

    const isReplicaSwitchDisable = computed(() => editable.value && (oldSessionDetail.value.replica && !isObjectEmpty(oldSessionDetail.value.replica)));

    const selectedDate = computed(() => store.getters.selectedDate);

    const minDate = computed(() => format(add(new Date(selectedDate.value), { days: 1 }), 'yyyy-MM-dd'));

    const dateModal = ref(false);
    const dialog = ref(null);

    const tabs = ref([
      { tabKey: 'REPLICATION_SIMPLE', label: 'Replication Simple', component: 'ReplicationSimple' },
      { tabKey: 'REPLICATION_ADVANCE', label: 'Replication Avancee', component: 'ReplicationAdvance' }
    ]);

    const saveDate = receivedDate => {
      dialog.value.save(receivedDate);
      dateModal.value = false;

      newSession.value.end_date = getUnixTime(endOfDay(new Date(sessionReplica.value.replica_end_date)));
    };

    const changeIsReplicaSelection = () => {
      if (!sessionReplica.value.isReplica) {
        newSession.value.recurring = false;
        resetReplica();
      }
    };

    const isTabDisable = computed(() => editable.value && (oldSessionDetail.value.replica && !isObjectEmpty(oldSessionDetail.value.replica)));

    return { isTabDisable, minDate, saveDate, sessionReplica, tabs, dateModal, dialog, selectedDate, changeIsReplicaSelection, isReplicaSwitchDisable };
  }
};
</script>
